import dayjs from "dayjs";

import { DAY_TIMESTAMP } from "app/pages/activation/components/AddonBanners/constants";
import { useLocalStorage } from "app/pages/activation/hooks/helpers/useLocalStorage";
import { useSessionStorage } from "app/pages/activation/hooks/helpers/useSessionStorage";

import {
    LOCALE_STORAGE_KEY_CLOSED_TIME,
    LOCALE_STORAGE_KEY_OPENED_TIME,
    SESSION_STORAGE_KEY_PACKAGE,
} from "./constants";

const getCurrentTimestamp = () => dayjs().unix();

const getOffsetTimestamp = (daysOffset: number) => daysOffset * DAY_TIMESTAMP;

export const useShouldBeAddonPopupVisible = () => {
    const { setLocalStorage, removeLocalStorage } = useLocalStorage();
    const { getSessionStorage } = useSessionStorage();

    const { purchasedPackage } = getSessionStorage(SESSION_STORAGE_KEY_PACKAGE, { purchasedPackage: null });

    const shouldBeOpened = useShouldBeOpened() && !purchasedPackage;

    const setOpenedTimestamp = () => {
        setLocalStorage(LOCALE_STORAGE_KEY_OPENED_TIME, getCurrentTimestamp());
        removeLocalStorage(LOCALE_STORAGE_KEY_CLOSED_TIME);
    };

    const setClosedTimestamp = () => {
        setLocalStorage(LOCALE_STORAGE_KEY_CLOSED_TIME, getCurrentTimestamp());
        removeLocalStorage(LOCALE_STORAGE_KEY_OPENED_TIME);
    };

    return { shouldBeOpened, setClosedTimestamp, setOpenedTimestamp };
};

const useShouldBeOpened = () => {
    const isVariation = false; // TODO: remove this when cleanup lnx-93-addon-popup test
    const { daysOffset = 0, closedDaysOffset = 0 } = {}; // TODO: remove this when cleanup lnx-93-addon-popup test

    const { getLocalStorage } = useLocalStorage();

    if (!isVariation) {
        return false;
    }

    const currentTimestamp = getCurrentTimestamp();
    const closedTime = +getLocalStorage(LOCALE_STORAGE_KEY_CLOSED_TIME, 0);

    if (closedTime) {
        const shouldBeDisplayedPopupClosedTimestamp =
            +getLocalStorage(LOCALE_STORAGE_KEY_CLOSED_TIME, 0) + getOffsetTimestamp(closedDaysOffset);

        return shouldBeDisplayedPopupClosedTimestamp <= currentTimestamp;
    }

    const shouldBeDisplayedPopupTimestamp =
        +getLocalStorage(LOCALE_STORAGE_KEY_OPENED_TIME, 0) + getOffsetTimestamp(daysOffset);

    return shouldBeDisplayedPopupTimestamp <= currentTimestamp;
};
